/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaskSubtaskInputDto } from './TaskSubtaskInputDto';
import {
    TaskSubtaskInputDtoFromJSON,
    TaskSubtaskInputDtoFromJSONTyped,
    TaskSubtaskInputDtoToJSON,
    TaskSubtaskInputDtoToJSONTyped,
} from './TaskSubtaskInputDto';

/**
 * 
 * @export
 * @interface CreateTaskRequestDto
 */
export interface CreateTaskRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateTaskRequestDto
     */
    name: string;
    /**
     * WorkType id
     * @type {string}
     * @memberof CreateTaskRequestDto
     */
    workTypeId: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTaskRequestDto
     */
    mandatory?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTaskRequestDto
     */
    requiresShutdown?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateTaskRequestDto
     */
    estimatedDurationMinutes?: number | null;
    /**
     * Part ids required by this task
     * @type {Array<string>}
     * @memberof CreateTaskRequestDto
     */
    partIds?: Array<string>;
    /**
     * Optional ordered checklist lines under this task
     * @type {Array<TaskSubtaskInputDto>}
     * @memberof CreateTaskRequestDto
     */
    subtasks?: Array<TaskSubtaskInputDto>;
}

/**
 * Check if a given object implements the CreateTaskRequestDto interface.
 */
export function instanceOfCreateTaskRequestDto(value: object): value is CreateTaskRequestDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('workTypeId' in value) || value['workTypeId'] === undefined) return false;
    return true;
}

export function CreateTaskRequestDtoFromJSON(json: any): CreateTaskRequestDto {
    return CreateTaskRequestDtoFromJSONTyped(json, false);
}

export function CreateTaskRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTaskRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'workTypeId': json['workTypeId'],
        'mandatory': json['mandatory'] == null ? undefined : json['mandatory'],
        'requiresShutdown': json['requiresShutdown'] == null ? undefined : json['requiresShutdown'],
        'estimatedDurationMinutes': json['estimatedDurationMinutes'] == null ? undefined : json['estimatedDurationMinutes'],
        'partIds': json['partIds'] == null ? undefined : json['partIds'],
        'subtasks': json['subtasks'] == null ? undefined : ((json['subtasks'] as Array<any>).map(TaskSubtaskInputDtoFromJSON)),
    };
}

export function CreateTaskRequestDtoToJSON(json: any): CreateTaskRequestDto {
    return CreateTaskRequestDtoToJSONTyped(json, false);
}

export function CreateTaskRequestDtoToJSONTyped(value?: CreateTaskRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'workTypeId': value['workTypeId'],
        'mandatory': value['mandatory'],
        'requiresShutdown': value['requiresShutdown'],
        'estimatedDurationMinutes': value['estimatedDurationMinutes'],
        'partIds': value['partIds'],
        'subtasks': value['subtasks'] == null ? undefined : ((value['subtasks'] as Array<any>).map(TaskSubtaskInputDtoToJSON)),
    };
}

